import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import PresentationToolbar from '../components/PresentationToolbar'
import PresentationBody from '../components/PresentationBody'
import PresentationGrid from '../components/PresentationGrid'

import {fetchPresentation, filterGroups} from '../actions/presentation'
import {setStationState} from '../actions/station'
import {fetchCamerasByPermission} from '../actions/camera'
import {subcribeTopic, unsubcribeTopic} from '../actions/mqtt'
import {CHANNEL_NEW_ALARM_STATE, CHANNEL_STATION_CONNECTION_STATUS} from '../constants/defaultValues'

class Presentation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribed: false,
      filterAlarms: [
        0, 1, 2
      ],
      filteredAlarms: true,
      filterConnection: 1,
      filteredConnection: false,
      filterGroups: this.props.filterGroups,
      filteredGroups: this.props.filterGroups.length > 0
        ? true
        : false,
      filterStation: '',
      filteredStation: false,
      disconnect: 0,
      dangerous: 1,
      warning: 0,
      normal: 0,
      viewGridType: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.stations) {
      const {stations, mqttConnected, filterGroups} = nextProps
      const subscribed = this.state.subscribed
      if (stations.length > 0 && mqttConnected && !subscribed) {
        const alarmTopics = stations.map((item) => {
          return `${CHANNEL_NEW_ALARM_STATE}/${item.SystemID}/${item.ID}`
        })
        const connectionTopics = stations.map((item) => {
          return `${CHANNEL_STATION_CONNECTION_STATUS}/${item.SystemID}/${item.ID}`
        })
        const topics = alarmTopics.concat(connectionTopics)

        this.props.dispatch(subcribeTopic(topics))
        this.setState({subscribed: true})
      }
      const disconnect = stations.filter(item => item.OnlineState === 0).length
      const dangerous = stations.filter(item => item.AlarmLevel === 2 && item.OnlineState === 1).length
      const warning = stations.filter(item => item.AlarmLevel === 1 && item.OnlineState === 1).length
      const normal = stations.filter(item => item.AlarmLevel === 0 && item.OnlineState === 1).length
      this.setState({
        disconnect: disconnect,
        dangerous: dangerous,
        warning: warning,
        normal: normal,
        filterGroups: nextProps.filterGroups,
        filteredGroups: nextProps.filterGroups.length > 0
          ? true
          : false
      })
    }
  }

  componentWillMount() {
    this.props.dispatch(fetchPresentation())
    this.props.dispatch(fetchCamerasByPermission())
  }

  componentWillUnmount() {
    const {stations} = this.props
    const alarmTopics = stations.map((item) => {
      return `${CHANNEL_NEW_ALARM_STATE}/${item.SystemID}/${item.ID}`
    })
    const connectionTopics = stations.map((item) => {
      return `${CHANNEL_STATION_CONNECTION_STATUS}/${item.SystemID}/${item.ID}`
    })
    const topics = alarmTopics.concat(connectionTopics)
    this.props.dispatch(unsubcribeTopic(topics))
  }

  handleStationSelection(station) {
    this.props.dispatch(setStationState(station))
  }

  handleFilterConnection = (connected) => {
    this.setState({
      filterConnection: connected,
      filteredConnection: true,
      filterAlarms: [
        0, 1, 2
      ],
      filteredAlarms: connected !== 0
        ? true
        : false,
      filteredStation: false
    })
  }

  handleFilterAlarms = (alarms) => {
    this.setState({
      filteredConnection: false, filterAlarms: alarms, filteredAlarms: true,
      filteredStation: false
    })
  }

  handleTreeSelect = (ids) => {
    this.setState({
      filteredGroups: ids.length > 0
        ? true
        : false,
      filterGroups: ids,
      filteredStation: false
    })
    this.props.dispatch(filterGroups(ids))
  }

  handleAutoCompleteSelect = (id) => {
    this.setState({
      filteredStation: true,
      filterStation: id
    })
  }

  handleViewChange = () => {
    this.setState({
      viewGridType: !this.state.viewGridType
    })
  }

  render() {
    const {
      stations,
      //filterGroups,
      groups,
      treeGroups,
      fetching,
      isMobile,
      camerasByPermission,
      cmrFetching
    } = this.props
    const {
      disconnect,
      dangerous,
      warning,
      normal,
      filteredConnection,
      filterConnection,
      filteredAlarms,
      filterAlarms,
      filteredGroups,
      filterGroups,
      filteredStation,
      filterStation,
      viewGridType
    } = this.state
    let filterStations = []
    const filterConnectionStations = filteredConnection
      ? stations.filter((station) => {
        return station.OnlineState === filterConnection
      })
      : [...stations]

    const filterAlarmStations = filteredAlarms
      ? filterConnectionStations.filter((station) => {
        const index = filterAlarms.findIndex((val) => {
          return (val === station.AlarmLevel && station.OnlineState === 1)
        })
        return index > -1
      })
      : [...filterConnectionStations]

    const filterGroupStations = filteredGroups
      ? filterAlarmStations.filter((station) => {
        const index = filterGroups.findIndex((val) => {
          return val === station.GroupID
        })
        return index > -1
      })
      : [...filterAlarmStations]
    filterStations = [...filterGroupStations]
    if (viewGridType) {
      const stationIDsHasCamera = camerasByPermission.map((item) => {
        return item.StationID
      })
      const filterCameras = filterStations.filter((station) => {
        const index = stationIDsHasCamera.findIndex((id) => {
          return id === station.ID
        })
        return index > -1
      })

      filterStations = [...filterCameras]
      filterStations.sort(function(a, b) {
        return a.Name.localeCompare(b.Name);
      })
    }

    if (filteredStation) {
      if (filterStation !== "") {
        filterStations = stations.filter((station) => {
          return filterStation === station.ID
        })
      }
    }
    const content = viewGridType
      ? <PresentationGrid stations={filterStations} fetching={fetching && cmrFetching} cameras={camerasByPermission} onRowSelection={(station) => this.handleStationSelection(station)}/>
      : <PresentationBody stations={filterStations} fetching={fetching} onRowSelection={(station) => this.handleStationSelection(station)}/>
    return (<div>
      <PresentationToolbar disconnect={disconnect} dangerous={dangerous} warning={warning} normal={normal} groups={groups} filterGroups={filterGroups} treeGroups={treeGroups} stations={stations} isMobile={isMobile} onTreeSelect={this.handleTreeSelect} onAutoCompleteSelect={this.handleAutoCompleteSelect} onFilterConnection={this.handleFilterConnection} onFilterAlarms={this.handleFilterAlarms} onViewChange={this.handleViewChange} viewGridType={viewGridType}/> {content}
    </div>);
  }
}

Presentation.propTypes = {
  dispatch: PropTypes.func,
  mqttConnected: PropTypes.bool,
  currentSystem: PropTypes.object,
  stations: PropTypes.array,
  filterGroups: PropTypes.array,
  groups: PropTypes.array,
  treeGroups: PropTypes.array,
  fetching: PropTypes.bool,
  error: PropTypes.string,
  camerasByPermission: PropTypes.array,
  cmrFetching: PropTypes.bool
}

const mapStateToProps = function(state) {
  return {
    mqttConnected: state.mqtt.connected,
    currentSystem: state.system.currentSystem,
    stations: state.presentation.stations,
    filterGroups: state.presentation.filterGroups,
    groups: state.group.groups,
    treeGroups: state.group.treeGroups,
    fetching: state.presentation.fetching,
    error: state.presentation.error,
    camerasByPermission: state.camera.camerasByPermission,
    cmrFetching: state.camera.fetching
  }
}

export default connect(mapStateToProps)(Presentation);



// WEBPACK FOOTER //
// ./src/pages/Presentation.js